import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const softwareGoalsEntrypoint = createEntryPoint({
	root: JSResourceForUserVisible(
		() => import(/* webpackChunkName: "async-atlas-goals-entrypoint" */ './src/ui'),
	),
	getPreloadProps: () => ({}),
});
